/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCommand = createReactComponent("command", "IconCommand", [
  [
    "path",
    {
      d: "M7 9a2 2 0 1 1 2 -2v10a2 2 0 1 1 -2 -2h10a2 2 0 1 1 -2 2v-10a2 2 0 1 1 2 2h-10",
      key: "svg-0"
    }
  ]
]);

export { IconCommand as default };
//# sourceMappingURL=IconCommand.js.map
